import { Box, Container } from '@chakra-ui/react';

import { UserDeal } from '../../utils';
import DashboardBackButton from '../DashboardBackButton';
import DashboardDownPaymentPage from './DashboardDownPaymentPage';

type PaymentsPageProps = {
  userDeal: UserDeal;
};

const PaymentsPage = ({ userDeal }: PaymentsPageProps) => (
  <Box>
    <Container maxW="container.xl" pt={2}>
      <DashboardBackButton />
    </Container>

    <Container maxW="container.xl" my="20px">
      {userDeal && <DashboardDownPaymentPage deal={userDeal} />}
    </Container>
  </Box>
);

export default PaymentsPage;
